import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=8b62c594&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=8b62c594&prod&lang=scss&"
import style1 from "./Company.vue?vue&type=style&index=1&id=8b62c594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports